import { QUERY_KEYS } from "@cnx/common";
import { useQueryClient } from "@tanstack/react-query";
import ChatContextPopover from "components/ChatContextPopover";
import ChatParticipants from "components/ChatParticipants";
import ChatRooms from "components/ChatRooms";
import { useState } from "react";
import { useChatPanelStore } from "stores/chatPanel";
import { ChatDiscussionView } from "./ChatDiscussionView";
import ChatHeaderPanel from "./ChatHeaderPanel";
import { useChatContextStore } from "./providers/ChatContextProvider";
import { ChatHeaderSkeleton } from "./ui/ChatHeaderSkeleton";

export const ChatContent = () => {
  const [showParticipants, setShowParticipants] = useState(false);
  const setIsPanelOpen = useChatPanelStore(store => store.setIsPanelOpen);
  const panelDiscussionId = useChatPanelStore(store => store.panelDiscussionId);
  const panelContextId = useChatPanelStore(store => store.panelContextId);
  const panelContext = useChatPanelStore(store => store.panelContext);
  const setPanelDiscussionId = useChatPanelStore(
    store => store.setPanelDiscussionId
  );
  const queryClient = useQueryClient();

  const { discussionContext, isChatLoading } = useChatContextStore();

  const handleClose = () => {
    setIsPanelOpen(false);
    setPanelDiscussionId(null);
  };

  const handleSelect = (discussionId: string, contextId?: string | null) => {
    queryClient.removeQueries({
      queryKey: [QUERY_KEYS.MESSAGES, discussionId],
    });
    setPanelDiscussionId(discussionId, contextId);
  };

  const handleGoBack = () => setPanelDiscussionId(null);

  if (panelDiscussionId && showParticipants) {
    return (
      <ChatParticipants
        discussionId={panelDiscussionId}
        onClose={() => setShowParticipants(false)}
        onClosePanel={handleClose}
      />
    );
  }

  if (panelDiscussionId || (panelContext && panelContextId)) {
    return (
      <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
        <ChatDiscussionView
          key={panelContextId ?? panelDiscussionId}
          header={
            isChatLoading ? (
              <ChatHeaderSkeleton
                onGoBack={handleGoBack}
                onClose={handleClose}
                className="border-b border-gray"
              />
            ) : (
              <ChatHeaderPanel
                onGoBack={handleGoBack}
                onClose={handleClose}
                onViewParticipants={() => setShowParticipants(true)}
                className="border-b border-gray"
              />
            )
          }
          popover={
            discussionContext ? (
              <ChatContextPopover discussionContext={discussionContext} />
            ) : null
          }
        />
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      <ChatRooms onSelect={handleSelect} onClose={handleClose} />
    </div>
  );
};
